
/**
 * 아이템 유형
 */
export type GetOrderInfo200ItemType = typeof GetOrderInfo200ItemType[keyof typeof GetOrderInfo200ItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOrderInfo200ItemType = {
  COURSE: 'COURSE',
  SUBSCRIPTION_PLAN: 'SUBSCRIPTION_PLAN',
} as const;
